<template>
  <div class="payment-success">
    <div class="success-card">
      <div class="success-icon-wrapper">
        <div class="success-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
      </div>

      <h2 class="success-title">Payment Successful!</h2>

      <p class="success-message">
        Your software license has been extended successfully.
        Thank you for your continued trust in Chrilan Technology Subscription.
      </p>

      <div class="payment-details">
        <div class="detail-row">
          <span class="detail-label">Customer</span>
          <span class="detail-value">{{ reference.debtor_name }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Amount Paid</span>
          <span class="detail-value amount">{{ $utils.formatMoney(reference.amount) }}</span>
        </div>
      </div>

      <div v-if="hasInvoice" class="success-actions">
        <a :href="invoiceUrl" target="_blank" rel="noopener" class="btn-primary">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
          </svg>
          View Receipt
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentSuccess',
  props: {
    reference: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasInvoice() {
      return this.reference && this.reference.salenum
    },
    invoiceUrl() {
      if (!this.hasInvoice) return '#'
      return `https://chrilantech.com/LytSoftPosOnline/api/PDFReport/getInvoiceFromSaleNumber/${this.reference.salenum}/burntofi_chrilan`
    }
  }
}
</script>

<style scoped>
.payment-success {
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}

.success-card {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 0.75rem;
  padding: 2.5rem;
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.success-icon-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.success-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.3s ease-out;
}

.success-icon svg {
  width: 40px;
  height: 40px;
  stroke: #ffffff;
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #22c55e;
  margin: 0 0 0.75rem 0;
}

.success-message {
  font-size: 0.9375rem;
  color: #52525b;
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
}

.payment-details {
  background: #fafafa;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.detail-row:not(:last-child) {
  border-bottom: 1px solid #e4e4e7;
}

.detail-label {
  font-size: 0.875rem;
  color: #71717a;
}

.detail-value {
  font-weight: 600;
  color: #18181b;
}

.amount {
  color: #22c55e;
  font-size: 1.125rem;
}

.success-actions {
  display: flex;
  justify-content: center;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #18181b;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  text-decoration: none;
  transition: all 0.2s;
}

.btn-primary:hover {
  background: #27272a;
  transform: translateY(-1px);
}

.icon {
  width: 1rem;
  height: 1rem;
}

@media (max-width: 576px) {
  .success-card {
    padding: 1.5rem;
  }

  .success-icon {
    width: 60px;
    height: 60px;
  }

  .success-icon svg {
    width: 30px;
    height: 30px;
  }
}
</style>
